import React from "react";
import { Button, Glyphicon } from "react-bootstrap";

export const AutoValidationErrorNotificationMessage = ({ message, onClick }) => (
  <div>
    {message}
    <br />
    <Button bsSize="xsmall" onClick={() => onClick()}>
      <Glyphicon glyph="export" />
      Export validation results
    </Button>
  </div>
);
